export default __webpack_public_path__ + "images/7D.a556181.png";